import _copyToClipboard from 'copy-to-clipboard'

export function copyTextToClipboard(text) {
  if (!text) {
    return false
  }
  return _copyToClipboard(text)
}
